import { useIntl } from 'react-intl';
import { ReactComponent as TimerIcon } from '../../../../../icons/icon-timer.svg';
import { useSelector } from 'react-redux';
import { selectProduct } from '../../../../../store/selectors/products';
import moment from 'moment';

const Timer = () => {
  const { formatMessage } = useIntl();
  const { data } = useSelector(selectProduct);
  const {
    qaAvailability: { availableAt, status },
  } = data;
  const today = moment();
  const expiresAt = moment(availableAt);
  const date = moment(availableAt).format('DD.MM.YYYY');
  const time = moment(availableAt).format('HH:mm');
  const qaEnvAvailabiltyDescription = status === 'new' ? 'Integration timer description new' : 'Integration timer description updated';
  const sameOrBeforeDate = today <= expiresAt;

  return (
    availableAt &&
    sameOrBeforeDate && (
      <div className='integration__timer'>
        <TimerIcon />

        <p>{formatMessage({ id: qaEnvAvailabiltyDescription })}</p>

        <div>
          <span className='integration__timer--date'>{date}</span>
          <span className='integration__timer--time'>{time}</span>
        </div>
      </div>
    )
  );
};

export default Timer;
